import React, { Component } from 'react'
import {
  Header,
  Footer,
  Card,
  PageWrapper,
  ListView,
  Arrow,
  XMText,
  XLMMText,
  FlexWrapper,
  Icon,
  XLMText,
  Circle,
  StyledFlex,
  Modal,
  TextField,
  FormikForm,
  StyledImage,
  Button,
  TextOverflow,
  WarningCard
} from '../components'
import { addList } from '../utlis/validators'
import qs from 'qs'
import Cookies from 'js-cookie'
import { API_URL } from '../constants'
import axios from 'axios'
import { get, sum } from 'lodash'
import { Formik, Field } from 'formik'

class List extends Component {
  state = { shoppingLists: [], showModal: false, grocerWarningCard: true }
  fetchUserLists = async () => {
    try {
      const query = {
        filter: {
          include: [{ products: ['product'] }]
        }
      }
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/shoppingLists?${qs.stringify(query)}`
      )
      await this.setState({ shoppingLists: data })
      console.log('shoppingLists', this.state.shoppingLists)
    } catch (error) {
      console.log('ERROR', error)
    }
  }

  fetchUserGrocer = async () => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id') }
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserGrocers?${qs.stringify(query)}`)
      this.setState({ userGrocer: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }
  async componentDidMount() {
    window.scrollTo(0, 0)
    await this.fetchUserGrocer()
    await this.fetchUserLists()
  }
  render() {
    const { shoppingLists, showModal } = this.state
    return (
      <React.Fragment>
        <Header
          title="Your Shopping Lists"
          showProfile
          onClickProfile={() => this.props.history.push('/user-profile')}
        />

        <PageWrapper viewPadding="22.4% 4.3%" height="auto" modifyPadding="70px 16px 84px">
          {this.state.grocerWarningCard && get(this.state, 'userGrocer', []).length === 0 && (
            <WarningCard
              onClickCard={() => this.props.history.push('/dashboard/shop/edit')}
              onClose={() => this.setState({ grocerWarningCard: false })}
              text="Where do you like to shop? Help us find the best stores for you."
            />
          )}
          <Card
            boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
            borderRadius="5px"
            bgColor="#fff"
            height="auto"
            padding={'16px'}>
            <ListView
              hideTop={
                <FlexWrapper
                  direction="row"
                  alignItems="center"
                  viewPadding="0 0 10px 0"
                  width="100%"
                  onClick={async () => {
                    await this.setState({ showModal: false, listExist: false })
                    this.setState({ showModal: true, createNew: true })
                  }}>
                  <FlexWrapper viewMargin="0 6px 0 0" flexBasis="6%">
                    <Icon icon="addToList" />
                  </FlexWrapper>
                  <XLMText color="#124b5f">Create New List</XLMText>
                </FlexWrapper>
              }
              component={shoppingLists.map(list => (
                <React.Fragment key={list.id}>
                  <FlexWrapper direction="row" alignItems="center">
                    <Circle size="52px" minWidth="52px" boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.19)">
                      <StyledImage
                        src={get(list.products[0], 'product.productImage', require('../static/images/empty-list.png'))}
                        height="36px"
                        maxWidth="36px"
                      />
                    </Circle>
                    <StyledFlex
                      direction="row"
                      viewMargin="0 0 0 20px"
                      viewPadding="16px 0"
                      alignItems="center"
                      height="70px"
                      justifyContent="space-between"
                      onClick={() => this.props.history.push(`/lists/${list.id}`)}>
                      <TextOverflow>
                        <XMText
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '120px'
                          }}>
                          {list.name}
                        </XMText>
                        {list.products.length > 0 && (
                          <XLMMText color="#9f9f9f">
                            {sum(get(list, 'products', '').map(item => item.quantity))} Items
                          </XLMMText>
                        )}
                      </TextOverflow>
                      <Arrow color="#124b5f" rotate="225" />
                    </StyledFlex>
                  </FlexWrapper>
                </React.Fragment>
              ))}
            />
          </Card>
        </PageWrapper>
        <Footer />
        <Modal
          title={'Create New List'}
          show={showModal}
          hide={!showModal}
          // list={openList || listExist}
          onClose={() => this.setState({ showModal: false })}>
          <FlexWrapper alignItems="center">
            <React.Fragment>
              <Formik
                enableReinitialize
                initialValues={{ title: '' }}
                validate={addList}
                validateOnChange
                onSubmit={async val => {
                  try {
                    const { data } = await axios.post(`${API_URL}/users/${Cookies.get('user_id')}/shoppingLists`, {
                      name: val.title,
                      userId: Cookies.get('user_id')
                    })
                    await this.setState({ showModal: false, createNew: false })
                    this.fetchUserLists()
                    // await this.setState({ listExist: true, showModal: true })
                    console.log('DATA LIST', data)
                  } catch (error) {
                    console.log('ERROR', error)
                  }
                }}
                render={formikBag => (
                  <FormikForm>
                    <Field
                      name="title"
                      render={({ field }) => (
                        <TextField {...field} width="auto" type="text" label="Title" error={formikBag.errors.title} />
                      )}
                    />
                    <FlexWrapper alignItems="center">
                      <Button
                        size="small"
                        label="Add"
                        namespace="Create List"
                        volume="filled"
                        margin="14px 0 0 0"
                        type="submit"
                      />
                    </FlexWrapper>
                  </FormikForm>
                )}
              />
            </React.Fragment>
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}

export default List



// WEBPACK FOOTER //
// ./src/pages/List.js